import { render, staticRenderFns } from "./ProductSales.vue?vue&type=template&id=77854664&scoped=true&"
import script from "./ProductSales.vue?vue&type=script&lang=js&"
export * from "./ProductSales.vue?vue&type=script&lang=js&"
import style0 from "./ProductSales.vue?vue&type=style&index=0&id=77854664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77854664",
  null
  
)

export default component.exports